import React from 'react'
import '../../css/footer.css'
import '../../css/Sidebar.css'

function Footer() {
  return (
    <>
        <div className='foot p-3 d-flex'>
            <div className="color-wh">
                © 2024 ALO
            </div>
            
        </div>
    </>
  )
}

export default Footer